import React, { FunctionComponent } from 'react';
import { PalletDetail } from '../../../types/palletDetail';

interface ModalDefects2TypeSelectionProps {
    pallets: PalletDetail[];
    handleChange: (e: React.ChangeEvent<HTMLInputElement>, dataKey: string) => void;
    translateString: Function;
    aplSettings: any;
    hideBlockPackaging: boolean;
    hideBlockQI: boolean;
    palletsHaveSameStatus: (pallets: any[], statusId: number) => boolean;
    }

const ModalDefects2TypeSelection: FunctionComponent<ModalDefects2TypeSelectionProps> = ({
  pallets,
  handleChange,
  translateString,
  aplSettings,
  hideBlockPackaging,
  hideBlockQI,
  palletsHaveSameStatus
}) => {
  return (
    <div className="block-type-selection mt-2">
      {!hideBlockPackaging && (
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="blockType"
            id="blockTypePackaging"
            value="12"
            checked={palletsHaveSameStatus(pallets, 12)}
            onChange={(e) => {handleChange(e, "")}}
          />
          <label className="form-check-label" htmlFor="blockTypePackaging">
            {translateString("blockPackaging", aplSettings.culture)}
          </label>
        </div>
      )}

      {!hideBlockQI && (
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="blockType"
            id="blockTypeQI"
            value="10"
            checked={palletsHaveSameStatus(pallets, 10)}
            onChange={(e) => {handleChange(e, "")}}
          />
          <label className="form-check-label" htmlFor="blockTypeQI">
            {translateString("blockQi", aplSettings.culture)}
          </label>
        </div>
      )}

      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          name="blockType"
          id="blockTypeResort"
          value="5"
          checked={palletsHaveSameStatus(pallets, 5)}
          onChange={(e) => {handleChange(e, "")}}
          />
        <label className="form-check-label" htmlFor="blockTypeResort">
          {translateString("blockResort", aplSettings.culture)}
        </label>
      </div>
    </div>
  );
};

ModalDefects2TypeSelection.defaultProps = {
  hideBlockPackaging: false,
  hideBlockQI: false
};

export default ModalDefects2TypeSelection;

